<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/beyond-ec/feature/summary.jpg'"
        :altText="`新・呼び出しシステムBeyond EC（ビヨンド イーシー）`"
        :headerText="
          `スマホがそのままレシーバーに !
          Wi-Fi 利用で呼び出しシステムは進化する。`
        "
        :detailText="
          `Beyond EC は、通信無料の特定小電力無線（920MHz 帯）と、Wi-Fi（無線 LAN）を組み合わせた呼び出しシステム。
          Wi-Fi を使うので専用のレシーバーは不要。お手持ちの Android スマホをそのまま表示機として利用できます。`
        "
        :color="'blue'"
      />

      <img
        class="feature-image"
        v-lazy="'/static/products/beyond-ec/feature/feature_01.png'"
      />

      <div class="feature-title">
        表示機（Androidスマホ）
      </div>

      <div
        class="feature-contents"
        style="display: flex; flex-wrap: wrap; justify-content: space-between;"
      >
        <div class="feature-content" style="margin-top: 0; width: 100%;">
          <content-header
            title="お手持ちのスマホがそのままレシーバーに"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            専用アプリをダウンロードすれば、スマホがそのままレシーバーに。操作は簡単、スワイプ／フリック／タップなど、スマホと同じく直感的に。
          </p>
          <p>
            着信音やバイブレーション設定なども多彩なメニューから選べます。
          </p>
        </div>
        <div class="feature-content vertical-content">
          <content-header
            title="「呼出中」をタップし情報を確認"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <div>
            <p>
              着信があれば「呼出中」をタップ。
            </p>
            <p>
              呼出元、呼出対象グループ、経過時間が順番に表示されます。
            </p>
          </div>
          <div
            style="margin-top: 20px; display: flex; justify-content: space-around;"
          >
            <img
              v-lazy="'/static/products/beyond-ec/feature/feature_02.png'"
              style="position: static; width: 40%; height: 100%;"
              :style="this.$isPC ? '' : 'width: 35%'"
            />
            <div style="width: 50%; display: grid" v-if="this.$isPC">
              <p style="line-height: 16px; margin-top: 30px;">
                スマホと呼出機を自由にひもづけ。<br />
                指定した呼出機の情報だけを<br />
                表示できます。<br />
                ※下記「グループ割当て機能」を参照
              </p>
              <p style="line-height: 16px; margin-top: 100px;">
                呼び出された順番にグループ名と<br />
                経過時間が表示されるので、<br />
                どの呼出機から、いつコールが<br />
                あったか、一目瞭然。
              </p>
              <p style="line-height: 16px; margin-top: 30px;">
                「呼出中」をタッチすれば、<br />
                呼出中の情報を表示。
              </p>
            </div>
            <div style="width: 60%; display: grid" v-else>
              <p style="line-height: 16px;">
                スマホと呼出機を自由にひもづけ。指定した呼出機の情報だけを表示できます。<br />
                ※下記「グループ割当て機能」を参照
              </p>
              <p style="line-height: 16px; margin-top: 15px;">
                呼び出された順番にグループ名と経過時間が表示されるので、
                どの呼出機から、いつコールがあったか、一目瞭然。
              </p>
              <p style="line-height: 16px; margin-top: 10px;">
                「呼出中」をタッチすれば、呼出中の情報を表示。
              </p>
            </div>
          </div>
        </div>
        <div class="feature-content vertical-content">
          <content-header
            title="「履歴」で対応記録を確認"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            「履歴」をタップすれば対応記録を表示。
          </p>
          <p>
            対応した担当者や時間などを表示します。
          </p>
          <div
            style="margin-top: 20px; display: flex; justify-content: space-around;"
          >
            <img
              v-lazy="'/static/products/beyond-ec/feature/feature_03.png'"
              style="position: static; width: 40%; height: 100%;"
              :style="this.$isPC ? '' : 'width: 35%'"
            />
            <div style="width: 50%; display: grid" v-if="this.$isPC">
              <p style="line-height: 16px; margin-top: 110px;">
                対応した担当者名と<br />
                対応時間など<br />
                対応記録を順番に表示。
              </p>
              <p style="line-height: 16px; margin-top: 85px;">
                最後に呼び出されたものが下に配置。
              </p>
              <p style="line-height: 16px; margin-top: 30px;">
                「履歴」をタッチすれば、<br />
                対応済みの情報を表示。
              </p>
            </div>
            <div style="width: 60%; display: grid" v-else>
              <p style="line-height: 16px; margin-top: 25px;">
                対応した担当者名と<br />
                対応時間など<br />
                対応記録を順番に表示。
              </p>
              <p style="line-height: 16px; margin-top: 25px;">
                最後に呼び出された<br />
                ものが下に配置。
              </p>
              <p style="line-height: 16px; margin-top: 5px;">
                「履歴」をタッチすれば、<br />
                対応済みの情報を表示。
              </p>
            </div>
          </div>
        </div>
        <div
          class="feature-content"
          style="width: 40%; margin-top: 0"
          :style="this.$isPC ? '' : 'width: 100%'"
        >
          <content-header
            title="横型レイアウトにも対応"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            画面は縦、横どちらにも対応します。
          </p>
          <p>
            スマホと同様、端末を回転することで自動的に表示が変わります。
          </p>
        </div>
        <div
          style="width: 60%; margin-top: 0; display: flex;justify-content: space-around;"
          :style="this.$isPC ? '' : 'width: 100%'"
        >
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_04.png'"
            style="width: 55%; height: 100%;"
          />
          <div
            style="width: 50%; display: grid; height: fit-content;"
            :style="this.$isPC ? '' : 'font-size: 13px'"
          >
            <p style="line-height: 16px; margin: 0">
              ギアマークを<br />
              クリックすると<br />
              設定メニューが表示
            </p>
            <p
              style="line-height: 16px; margin-top: 35px"
              :style="this.$isPC ? '' : 'margin-top: 5px'"
            >
              最後に呼び出されたものが右に配置。
            </p>
          </div>
        </div>
      </div>

      <div class="feature-title">
        グループ割当て機能
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            title="呼び出したいスマホを自由に設定"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            呼出機とレシーバーを自由にひもづけられる「グループ割当機能」を搭載。
          </p>
          <p>
            呼出機<span style="color: rgb(0,95,255); font-weight: bold;">
              ❶（青色）</span
            >はグループ A のレシーバーに、呼出機
            <span style="color: rgb(255,220,92); font-weight: bold;">
              ❷（黄色）</span
            >はグループ B、呼出機
            <span style="color: rgb(255,0,116); font-weight: bold;">
              ❸（ピンク）</span
            >はグループ C…というように、
          </p>
          <p>呼び出したい対象（スマホ）を自由に設定できます。</p>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_05.png'"
            style="position: inherit; width: 100%; margin-top: 25px;"
          />
        </div>
        <div class="feature-content">
          <content-header
            title="液晶モニターで、呼出／応対の状況を一目瞭然に把握できます。"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            受信機に液晶モニターを接続すれば、最大 12
            件の呼出情報を表示。現場の状況を一元的にチェックすることができます。
          </p>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_06.png'"
            style="position: inherit; width: 100%; margin-top: 25px;"
          />
        </div>
      </div>

      <div class="feature-title">
        受信機＆表示用液晶モニター
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            title="呼出機の信号を Wi-Fi で表示機（スマホ）へ"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            呼出機からの信号を受信し、Wi-Fi( 無線 LAN) で Android
            スマホに送信します。受信機と液晶モニターを HDMI
            ケーブルで接続すれば呼出の情報を表示できます。
          </p>
          <p>
            受信機に接続されたモニター表示と表示機 (Android スマホ )
            は連動しており、表示機 (Android スマホ )
            での対応をリアルタイムでモニターに反映します。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            title="最大 12 件の呼び出し情報を表示"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            呼び出し情報を 12
            件まで、液晶モニターに表示。最も新しい呼び出し情報は右下に配置されます。
            呼び出しを受けた担当者が対応すれば自動的に画面から消去され、未対応の情報が繰り上がります。
            また特定の呼出機の情報を先頭に表示できる優先表示機能も搭載しています。
          </p>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_07.png'"
            style="position: static; width: 100%; margin-top: 25px"
          />
        </div>
        <div class="feature-content">
          <content-header
            title="呼び出し元、呼び出し対象、経過時間が一目で分かる"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            :style="this.$isPC ? 'width: 55%' : 'width: 100%'"
          />
          <div style="width: 50%">
            <p>
              どの場所から誰への呼び出しがあったのか、呼び出してからどれほどの時間が
            </p>
            <p>
              経過したかが表示されます。
            </p>
          </div>
          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_08.png'"
            style="height: auto;"
            :style="
              this.$isPC ? 'top: -40px; width: 40%;' : 'top: 90px; width: 40%;'
            "
          />
        </div>
      </div>

      <div class="feature-title">
        Windowsパソコン
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            title="各種設定やログ管理は Windows PC で"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
            :style="this.$isPC ? 'width: 55%' : 'width: 100%'"
          />
          <div v-if="this.$isPC">
            <p>Windows PC を接続（無線／有線）し、</p>
            <p>呼出機やレシーバー（スマホ）の登録、各種設定を行います。</p>
            <p>Web ブラウザの設定画面でどなたでも簡単に操作できます。</p>
            <p>また専用アプリを用いれば呼び出し／受信／対応などのログ情報を</p>
            <p>CSV ファイルでダウンロード。</p>
            <p>呼び出しの発生場所や回数、時間帯などを把握できます。</p>
          </div>
          <div v-else>
            <p>
              Windows PCを接続（無線／有線）し、
              呼出機やレシーバー（スマホ）の登録、各種設定を行います。
            </p>
            <p>Web ブラウザの設定画面でどなたでも簡単に操作できます。</p>
            <p>
              また専用アプリを用いれば呼び出し／受信／対応などのログ情報をCSV
              ファイルでダウンロード。
            </p>
            <p>
              呼び出しの発生場所や回数、時間帯などを把握できます。
            </p>
          </div>

          <img
            v-lazy="'/static/products/beyond-ec/feature/feature_09.png'"
            style="height: auto;"
            :style="
              this.$isPC
                ? 'top: -20px; width: 40%;'
                : 'width: 100%; position: static; margin-top: 10px;'
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <span class="circle-heading-title"> 導入いただく<br />機器 </span>
        </div>
      </div>

      <div class="main-function blue">
        <div class="body">
          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre" style="padding-left: 2%">
                電池レス呼出機
              </h3>
              <div class="product-detail">
                <p>電磁誘導式自己発電部内蔵型のコードレスチャイム</p>
              </div>
            </div>
            <div style="padding-top: 10px">
              ボタンを押すだけで自ら発電し、受信機との通信（特定小電力 920MHz
              帯）が可能です。<br />
              登録は受信機の「登録ボタン」でペアリングモードにして行います。<br />
              メッセージの設定は、受信機と Windows PC を有線／無線 LAN
              で接続。PC の Web ブラウザから行います。<br />
              5
              ボタン型は、ボタンごとに呼び出すグループを指定することができます。
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_10.png'"
              style="height: auto"
            />
          </div>

          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">外部入力型送信機</h3>
              <div class="product-detail">
                <p>無人運転機器に接続可能な</p>
                <p>信号入力型送信機</p>
              </div>
            </div>
            <p>
              スイッチやリレーなどの ON
              信号を受けて送信し、無人運転機器等にトラブルが発生した場合に、受信機へ自動送信できます。（2
              入力対応）電源は単三アルカリ乾電池 2 本または AC
              アダプタに対応します。電池と AC アダプタを併用する場合は AC
              アダプタが優先され、AC
              アダプタからの供給がストップすると乾電池で作動します。
            </p>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_11.png'"
              style="height: auto;"
              :style="this.$isPC ? 'width: 100%' : 'width: 80%; height: auto;'"
            />
          </div>
          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">受信機</h3>
              <div class="product-detail">
                <p>呼出機の信号を受信し、その信号をWi-Fiを</p>
                <p>使ってAndroidスマホに送ります。</p>
              </div>
            </div>
            <p>
              液晶モニターを HDMI
              ケーブルで接続すれば呼び出し情報を表示することができます。また稼働後は、有線／無線
              LAN で接続された WindowsPC
              でログ管理や設定変更を行えます。呼出機や消去機、表示機の登録／設定は、受信機と
              WindowsPC を有線／無線 LAN で接続。PC の Web
              ブラウザから行います。
            </p>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_12.png'"
            />
          </div>

          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">中継機</h3>
              <div class="product-detail">
                <p>設定不要で、電源にさえ接続していれば、</p>
                <p>使用できます。</p>
              </div>
            </div>
            <p>
              送信機や他の中継機からの電波信号を中継し、遠距離通信を可能にします。
            </p>
            <p style="font-weight: bold">［中継機の設置について］</p>
            <p>
              中継機は呼出機と受信機の中間に設置し、通信距離を延長します。受信機の受信可能距離を上回ったり、障害により電波の受信状況が悪い場所に設置してください。
            </p>
            <div>
              ※呼出機から中継機・受信機への電波到達距離は、ご使用の環境によって異なります。<br />
              ※高温、多湿、ホコリの影響を受けない場所に設置してください。<br />
              ※本製品は防水ではありません。単独での屋外設置は避けてください。
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_13.png'"
              style="width: 80%; height: auto;"
            />
          </div>
          <div
            class="product-block"
            :style="this.$isPC ? 'width: 45%; margin: 20px auto 0 0;' : ''"
          >
            <div class="product-block-header">
              <h3 class="product-genre">電池レス消去機</h3>
              <div class="product-detail">
                <p>呼出機と同じく電池レスの</p>
                <p>消去機です。</p>
              </div>
            </div>
            <p>
              呼出機側での呼出消去、または、Androidスマホでの呼出消去の
              運用が難しい場合等、モニターに表示された呼出情報を上下左右
              のコントロール操作により消去を行います。
            </p>
            <img
              class="product-image"
              v-lazy="'/static/products/beyond-ec/feature/feature_14.png'"
              style="width: 80%; height: auto;"
            />
            <p>消去用赤枠を消去機にてコントロールし消去</p>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <span class="circle-heading-title"> システム<br />構成 </span>
        </div>
      </div>
      <div class="system-config">
        <img v-lazy="'/static/products/beyond-ec/feature/system.png'" />
      </div>
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/1" target="_blank"
            ><img
              src="/static/columns/24/rest_mv.png"
              alt="飲食店の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/1" target="_blank"
              >飲食店の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/1" target="_blank"
            ><img
              src="/static/columns/1/img_hospital_waiting_time1.jpg"
              alt="【病院関係者向け】待ち時間対策の重要性や効果的な方法を解説！"
          /></a>

          <h3>
            <a href="/column/1" target="_blank"
              >【病院関係者向け】待ち時間対策の重要性や効果的な方法を解説！</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/2" target="_blank"
            ><img
              src="/static/columns/2/img_nurse_call_usage1.jpg"
              alt="ナースコールの使い方を4つのタイプ別に解説！活用のポイントも"
          /></a>

          <h3>
            <a href="/column/2" target="_blank"
              >ナースコールの使い方を4つのタイプ別に解説！活用のポイントも</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
  },
}
</script>

<style scoped>
.feature-section .header h2 {
  color: rgb(16, 106, 203);
}

.feature-title {
  font-size: 20px;
  font-weight: bold;

  display: inline-block;

  margin: 30px 0 10px;
  padding: 0 25px;

  color: white;
  border-radius: 20px;
  background-color: rgb(16, 106, 203);
}

.sp-product .feature-content {
  margin: 20px 0;
}

.feature-section .main-function {
  background-color: rgb(242, 246, 250);
}

.feature-section .main-function .body {
  width: 90%;
  max-width: 1100px;
}

.feature-section .main-function .body .product-block {
  width: 100%;
  margin: 20px 0;
}

.feature-section .main-function .body .product-block .content-header {
  font-size: 18px;

  margin-bottom: 20px;
}

.feature-section .main-function .body .functions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.sp-product .feature-section .main-function .body .functions {
  flex-direction: column;
}

.feature-section .main-function .body .functions .function {
  width: 45%;
  margin-bottom: 10px;

  border: none;
}

.sp-product .feature-section .main-function .body .functions .function {
  width: 100%;
}

.function .function-title {
  padding-bottom: 5px;

  border-bottom: 1px solid rgb(178, 194, 201);
}

.feature-section .main-function .body .vertical-functions {
  display: inline-block;

  width: 80%;
}

.feature-section .main-function .body .vertical-functions .function {
  margin-bottom: 10px;

  border: none;
}

.feature-image {
  display: block;

  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.feature-top .feature-contents .feature-content.vertical-content {
  position: static;

  width: 45%;
  margin: 0 0 50px;
}

.sp-product .feature-top .feature-contents .feature-content.vertical-content {
  width: 100%;
  max-width: 400px;
  margin-bottom: 10px;
}

.feature-section
  .main-function
  .body
  .product-block
  .product-block-header
  .product-genre {
  width: 96%;
  margin-bottom: 10px;
  padding: 3px 0 3px 4%;
  text-align: left;
  border-radius: 20px;
}

.feature-section .system-config {
  background: linear-gradient(rgb(228, 236, 243), white);
}

.feature-section .system-config img {
  width: 90%;
  max-width: 1100px;
  padding: 120px 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/BeyondEc.vue